import { render, staticRenderFns } from "./CustomerInquiryCategory.vue?vue&type=template&id=0d3e01d2&scoped=true"
import script from "./CustomerInquiryCategory.vue?vue&type=script&lang=js"
export * from "./CustomerInquiryCategory.vue?vue&type=script&lang=js"
import style0 from "./CustomerInquiryCategory.vue?vue&type=style&index=0&id=0d3e01d2&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e01d2",
  null
  
)

export default component.exports